import type { CalendarViewMode } from '@/types/calendarTypes';

export function mapViewToFullCalendar(view: CalendarViewMode): string {
  if (view === 'day') return 'timeGridDay';
  if (view === 'week') return 'timeGridWeek';
  return 'dayGridMonth';
}

export function fullCalendarViewToMode(viewType: string): CalendarViewMode {
  if (viewType === 'timeGridDay') return 'day';
  if (viewType === 'timeGridWeek') return 'week';
  return 'month';
}
